(() => {
  const getOfferCopy = (itemCount) => {
    const count = Math.max(0, Number(itemCount) || 0);
    const freeItems = Math.floor(count / 3);
    const remainder = count % 3;
    const freeItemLabel = `${freeItems} free item${freeItems === 1 ? '' : 's'}`;

    if (count === 0) {
      return {
        message: 'Buy any 2 pieces and choose a third free. The lowest-priced item in each set is free.',
        button: 'Shop the offer',
      };
    }

    if (remainder === 0) {
      return {
        message: `${freeItemLabel} ${freeItems === 1 ? 'is' : 'are'} in your cart. Add 3 more pieces to receive another free item.`,
        button: 'Build another set',
      };
    }

    if (remainder === 1) {
      return {
        message:
          freeItems > 0
            ? `${freeItemLabel} in your cart. Add one more piece, then choose another free piece.`
            : 'Add one more piece, then choose your free piece.',
        button: 'Keep shopping',
      };
    }

    return {
      message:
        freeItems > 0
          ? `${freeItemLabel} in your cart. Choose one more piece as your next free item.`
          : 'Choose one more piece as your free item.',
      button: 'Choose your free piece',
    };
  };

  const updateOfferProgress = (itemCount) => {
    const copy = getOfferCopy(itemCount);

    document.querySelectorAll('[data-qh-offer-progress]').forEach((offer) => {
      offer.dataset.cartCount = itemCount;

      const message = offer.querySelector('[data-qh-offer-message]');
      const button = offer.querySelector('[data-qh-offer-link]');

      if (message) message.textContent = copy.message;
      if (button) button.textContent = copy.button;
    });
  };

  let requestNumber = 0;

  const refreshOfferProgress = async () => {
    const currentRequest = ++requestNumber;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const cart = await response.json();
      if (currentRequest === requestNumber) updateOfferProgress(cart.item_count);
    } catch (error) {
      console.warn('Unable to refresh offer progress.', error);
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const itemCount = event?.cartData?.item_count;

      if (Number.isInteger(itemCount)) {
        requestNumber += 1;
        updateOfferProgress(itemCount);
      } else {
        refreshOfferProgress();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const offer = document.querySelector('[data-qh-offer-progress]');
    if (offer) updateOfferProgress(offer.dataset.cartCount);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshOfferProgress();
  });
})();
